export const siteSettings = {
  name: "Trust Pro Desk",
  link: "https://trustprodesk.com",
  email: "support@trustprodesk.com",
  appLink: "https://dashboard.trustprodesk.com",
};
